import { listOf1jh22dvmctj1r as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Companion_getInstancenv8qpb0wanrh as Companion_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Paint.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var ColorSetClass;
function ColorSet() {
  if (ColorSetClass === VOID) {
    class $ {
      constructor(name, dark, main, light1, light2, light3) {
        this.xg9_1 = name;
        this.yg9_1 = dark;
        this.zg9_1 = main;
        this.aga_1 = light1;
        this.bga_1 = light2;
        this.cga_1 = light3;
      }
      tjn() {
        return listOf([this.yg9_1, this.zg9_1, this.aga_1, this.bga_1, this.cga_1]);
      }
      toString() {
        return 'ColorSet(name=' + this.xg9_1 + ', dark=' + this.yg9_1.toString() + ', main=' + this.zg9_1.toString() + ', light1=' + this.aga_1.toString() + ', light2=' + this.bga_1.toString() + ', light3=' + this.cga_1.toString() + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.xg9_1);
        result = imul(result, 31) + this.yg9_1.hashCode() | 0;
        result = imul(result, 31) + this.zg9_1.hashCode() | 0;
        result = imul(result, 31) + this.aga_1.hashCode() | 0;
        result = imul(result, 31) + this.bga_1.hashCode() | 0;
        result = imul(result, 31) + this.cga_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ColorSet()))
          return false;
        if (!(this.xg9_1 === other.xg9_1))
          return false;
        if (!this.yg9_1.equals(other.yg9_1))
          return false;
        if (!this.zg9_1.equals(other.zg9_1))
          return false;
        if (!this.aga_1.equals(other.aga_1))
          return false;
        if (!this.bga_1.equals(other.bga_1))
          return false;
        if (!this.cga_1.equals(other.cga_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ColorSet');
    ColorSetClass = $;
  }
  return ColorSetClass;
}
var AppColorsClass;
function AppColors() {
  if (AppColorsClass === VOID) {
    class $ {
      constructor() {
        AppColors_instance = this;
        this.efz_1 = new (ColorSet())('purple', Companion_getInstance().ccz('210840'), Companion_getInstance().ccz('421976'), Companion_getInstance().ccz('715298'), Companion_getInstance().ccz('C0B3D2'), Companion_getInstance().ccz('EDEAF3'));
        this.ffz_1 = new (ColorSet())('green', Companion_getInstance().ccz('005526'), Companion_getInstance().ccz('00ab4d'), Companion_getInstance().ccz('50C685'), Companion_getInstance().ccz('A1E1BD'), Companion_getInstance().ccz('E9F8F0'));
        this.gfz_1 = new (ColorSet())('yellow', Companion_getInstance().ccz('B48400'), Companion_getInstance().ccz('f2ba1c'), Companion_getInstance().ccz('F7D575'), Companion_getInstance().ccz('FBEBBC'), Companion_getInstance().ccz('FEFAED'));
        this.hfz_1 = new (ColorSet())('neutrals', Companion_getInstance().ccz('201F1F'), Companion_getInstance().ccz('8D8B8B'), Companion_getInstance().ccz('D6D6D6'), Companion_getInstance().ccz('F0F1F1'), Companion_getInstance().ccz('FAFAFA'));
        this.ifz_1 = Companion_getInstance().bcz(5526612);
        this.jfz_1 = new (ColorSet())('red', Companion_getInstance().ccz('7C1400'), Companion_getInstance().ccz('F72700'), Companion_getInstance().ccz('FA755C'), Companion_getInstance().ccz('FCA899'), Companion_getInstance().ccz('FFF2F0'));
        this.kfz_1 = new (ColorSet())('yellow', Companion_getInstance().ccz('B48400'), Companion_getInstance().ccz('f2ba1c'), Companion_getInstance().ccz('F7D575'), Companion_getInstance().ccz('FBEBBC'), Companion_getInstance().ccz('FEFAED'));
        this.lfz_1 = new (ColorSet())('blue', Companion_getInstance().ccz('263062'), Companion_getInstance().ccz('5271ff'), Companion_getInstance().ccz('92A3F1'), Companion_getInstance().ccz('C8D1F8'), Companion_getInstance().ccz('EFF2FF'));
        this.mfz_1 = new (ColorSet())('purple', Companion_getInstance().ccz('4F1994'), Companion_getInstance().ccz('7b22ed'), Companion_getInstance().ccz('AA6FF6'), Companion_getInstance().ccz('D1B3F8'), Companion_getInstance().ccz('E9E1F4'));
        this.nfz_1 = Companion_getInstance().ccz('02843D');
      }
    }
    initMetadataForObject($, 'AppColors');
    AppColorsClass = $;
  }
  return AppColorsClass;
}
var AppColors_instance;
function AppColors_getInstance() {
  if (AppColors_instance === VOID)
    new (AppColors())();
  return AppColors_instance;
}
//region block: exports
export {
  AppColors_getInstance as AppColors_getInstance3ty7139j9u8g2,
};
//endregion

//# sourceMappingURL=AppColors.mjs.map
